import { buildValidations, validator } from 'ember-cp-validations';
import Model, { attr, belongsTo } from '@ember-data/model';

const Validations = buildValidations({
  relatedClient: validator('belongs-to', {
    descriptionKey: 'errors.clientRelationship.relatedClient',
    messageKey: 'errors.presence',
  }),
});

export default class ClientRelationshipModel extends Model.extend(Validations) {
  @belongsTo('base-client', { polymorphic: true, async: false, inverse: null }) relatedClient;
  @attr('boolean', { defaultValue: false }) billingDelegation;

  static fieldsFor(_context) {
    return ['billingDelegation'];
  }
}
